import { RootState } from 'store';

export const selectors = {
  selectDirection: (state: RootState) => state.direction.direction,
};
